import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  class: "flow-container"
};
var _hoisted_2 = {
  class: "node"
};
var _hoisted_3 = {
  class: "node-title"
};
var _hoisted_4 = {
  class: "node-len"
};
var _hoisted_5 = {
  class: "infos"
};
var _hoisted_6 = {
  style: {
    "margin-right": "60px"
  }
};
var _hoisted_7 = {
  class: "avatar"
};
var _hoisted_8 = ["src"];
var _hoisted_9 = {
  key: 1,
  class: "default-avatar"
};
var _hoisted_10 = {
  class: "approver-name",
  style: {
    "margin-top": "10px"
  }
};
var _hoisted_11 = {
  class: "approver-name",
  style: {
    "margin-left": "20px"
  }
};
import { approval_view } from "@/api/apis";
import { ref, watch } from "vue";
export default {
  __name: 'flows',
  props: ["origin_id", "approval_flow_id"],
  setup(__props) {
    var props = __props;
    var flowData = ref([]);
    var getlist = (origin_id, approval_flow_id) => {
      approval_view({
        origin_id,
        approval_flow_id
      }).then(res => {
        flowData.value = res.data || [];
      });
    };
    watch(() => {
      return props;
    }, val => {
      if (val && val.approval_flow_id && val.origin_id) {
        getlist(val.origin_id, val.approval_flow_id);
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      var _component_el_timeline_item = _resolveComponent("el-timeline-item");
      var _component_el_timeline = _resolveComponent("el-timeline");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_timeline, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flowData.value, (node, index) => {
          return _openBlock(), _createBlock(_component_el_timeline_item, {
            key: index,
            placement: "top",
            size: "large",
            type: node.status == 2 ? 'success' : node.status == 1 ? 'warning' : node.status == 3 ? 'danger' : 'info',
            icon: node.status == 2 ? 'Check' : node.status == 1 ? 'More' : node.status == 3 ? 'Close' : ''
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_3, _toDisplayString(node.node_name), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(node.user_info.length + "人审批"), 1)]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(node.user_info, (approver, approverIndex) => {
              return _openBlock(), _createElementBlock("div", {
                key: approverIndex,
                class: "approver-item"
              }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [approver.avatar ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: approver.avatar,
                alt: "avatar"
              }, null, 8, _hoisted_8)) : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(approver.approver_user_name.charAt(0)), 1))]), _createElementVNode("div", _hoisted_10, _toDisplayString(approver.approver_user_name) + "（" + _toDisplayString(approver.status) + "） ", 1)]), _createElementVNode("div", _hoisted_11, _toDisplayString(approver.approval_at), 1)]);
            }), 128))])])]),
            _: 2
          }, 1032, ["type", "icon"]);
        }), 128))]),
        _: 1
      })]);
    };
  }
};